import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import * as fromRocReportTransient from '@main-application/dashboard-reports/roc-report/store/index';
import { RocEffects } from '@main-application/dashboard-reports/roc-report/store/roc.effects';
import * as fromRocReportReducer from '@main-application/dashboard-reports/roc-report/store/roc.reducer';
import { metaRocReducers } from '@main-application/dashboard-reports/roc-report/store/roc.reducer';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([RocEffects]),
    StoreModule.forFeature(fromRocReportReducer.rocFeatureKey, fromRocReportReducer.reducer, {
      metaReducers: metaRocReducers,
    }),
    StoreModule.forFeature(fromRocReportTransient.rocReportTransientFeatureKey, fromRocReportTransient.reducer),
  ],
})
export class RocReportStoreModule {}
